import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Tab, Button } from 'semantic-ui-react'

import { scrollToFirstValidateFailElement } from 'core/utilities'
import { trackingDetailPath } from 'routes'
import RequestInfo from './RequestInfo'
import Summary from './PRSummary'
import PRAttachment from './PRAttachment'
import PRProcessHistory from './PRProcessHistory'
import ActionCommentModal from './ActionCommentModal'
import PRDetail from './PRDetail'
import PRStep from './PRStep'
import PRAction from './PRAction'
import K2ErrorModal from './K2ErrorModal'
import { getPRDetail, initializeDetailPR, addSpecialComment } from 'ducks/purchaseRequisition'
import { getWbsElements } from 'ducks/options'
import { MainBodyContent } from 'components'

const PRDetails = (props) => {
  const {
    prData,
    prLoading,
    approvers,
    approverAction,
    checkK2Error,
    wbsOptions,
    valueForm,
    history
  } = props

  const [showDialogComment, setShowDialogComment] = useState(false)

  const panes = [
    { menuItem: 'Summary&General', render: () => <Summary /> },
    { menuItem: 'Detail', render: () => <PRDetail /> },
    { menuItem: 'Attachment', render: () => <PRAttachment /> },
    {
      menuItem: 'Comment History', render: () => <PRProcessHistory
        accessoriesHeader={valueForm.canComment ?
          <Button
            type='button'
            content='Add Comment'
            color='blue'
            icon='plus'
            style={{ marginRight: '0.3125rem' }}
            onClick={() => {
              setShowDialogComment(true)
            }}
          />
          : null} />
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0)
    props.initializeDetailPR()
    props.getPRDetail(props.match.params.prId, props.history)
  }, [])

  useEffect(() => {
    if (Object.keys(prData).length) {
      if (wbsOptions.data[0]) {
        if (wbsOptions.data[0].companyCode === prData.companyCode) {
          props.getWbsElements(prData.companyCode)
        }
      } else {
        props.getWbsElements(prData.companyCode)
      }
    }
  }, [prData])

  const gotoTracking = () => {
    window.open(trackingDetailPath(prData.id))
  }

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
      .then(() => {
        if (!valueForm.actionComment) {
          scrollToFirstValidateFailElement({ actionComment: 'Required!' })
          throw new SubmissionError({ actionComment: 'Required!' })
        } else {
          props.addSpecialComment(valueForm.id, {
            comment: valueForm.actionComment,
            file: valueForm.attachFile
          }, history)
          setShowDialogComment(false)
        }
      })
  }

  return (
    <MainBodyContent
      headerTitle={`Purchase Requisition${prData.documentNumber ? ` - ${prData.documentNumber}` : ''}`}
      priority={prData && prData.priority}
      accessoriesHeader={
        !prLoading && prData.status !== 0 &&
        <Button
          basic
          circular
          type='button'
          content='Tracking'
          labelPosition='right'
          icon='code branch'
          onClick={() => (gotoTracking())} />
      }
      accessoriesHeaderLeft={
        !prLoading && checkK2Error &&
        <K2ErrorModal />
      }
    >
      {!prLoading && approvers && Object.keys(prData).length ?
        <PRStep /> : null
      }
      <RequestInfo />
      {!prLoading && approverAction &&
        <PRAction history={props.history} />
      }
      {!prLoading && Object.keys(prData).length &&
        <Tab
          style={{ flex: 1, marginTop: '1rem', 'div.ui.menu': { overflowX: 'scroll' } }}
          menu={{ attached: false }}
          panes={panes} />
      }
      {showDialogComment && <ActionCommentModal submit={props.handleSubmit(() => onSubmitForm())} setShowDialogComment={setShowDialogComment} actionName={'addComment'} requireComment includeFile showMessage={false} />}
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  let prDetail = state.pr.prDetail
  return {
    initialValues: {
      ...prDetail.data
    },
    prData: prDetail.data,
    prLoading: prDetail.loading,
    approvers: state.pr.approvers,
    approverAction: state.pr.approverAction,
    checkK2Error: state.pr.checkK2Error,
    user: state.authen.user,
    wbsOptions: state.options.wbsElements,
    valueForm: getFormValues('formEditPR')(state) || {},
  }
}
const mapDispatchToProps = {
  getPRDetail,
  initializeDetailPR,
  getWbsElements,
  addSpecialComment
}

const PRDetailForm = reduxForm({
  form: 'formEditPR',
  enableReinitialize: true,
})(PRDetails)

export default connect(mapStateToProps, mapDispatchToProps)(PRDetailForm)
